<template>
  <v-form
    ref="investorTransaction"
    @submit.prevent="editItem ? onUpdate() : onSubmit()"
  >
    <v-menu
      v-if="!topUp"
      v-model="dateMenu"
      :close-on-content-click="false"
      :nudge-right="40"
      transition="scale-transition"
      offset-y
      min-width="auto"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          v-model="formData.created_at"
          readonly
          dense
          outlined
          v-bind="attrs"
          v-on="on"
          :label="$t('dtp.paymentDate')"
          :rules="[isRequired]"
        ></v-text-field>
      </template>
      <v-date-picker
        v-model="formData.created_at"
        :locale="$i18n.locale"
        @input="dateMenu = false"
      ></v-date-picker>
    </v-menu>

    <v-text-field
      v-model="formData.amount"
      dense
      outlined
      :label="$t('common.fields.sum')"
      :rules="[isRequired, onlyNumbers]"
    />

    <v-select
      v-model="formData.payment_type"
      dense
      outlined
      item-text="name"
      item-value="id"
      :label="$t('common.fields.paymentMethod')"
      :items="paymentTypes"
      :item-disabled="isItemDisable"
      :rules="[isRequired]"
    />

    <v-text-field
      v-model="formData.comment"
      dense
      outlined
      :label="$t('common.fields.comment')"
    />

    <v-btn type="submit" color="warning" elevation="0" block :loading="loading">
      {{ $t('common.btns.save') }}
    </v-btn>
  </v-form>
</template>

<script>
export default {
  props: {
    opened: {
      type: Boolean,
      default: false,
    },
    investorId: {
      type: Number,
      required: true,
    },
    topUp: {
      type: Boolean,
      default: false,
    },
    editItem: {
      type: [Object, null],
      default: null,
    },
  },
  data: () => ({
    loading: false,
    dateMenu: false,
    formData: {
      created_at: '',
      amount: '',
      payment_type: '',
      comment: '',
    },
  }),
  watch: {
    opened(val) {
      if (!val) {
        this.$refs.investorTransaction.reset();
      }
    },
    editItem: {
      deep: true,
      immediate: true,
      handler(data) {
        if (!data) return;

        [this.formData.created_at] = data.created_at.split(' ');
        this.formData.amount = Math.abs(data.amount);
        this.formData.payment_type = data.type;
        this.formData.comment = data.comment;
      },
    },
  },
  computed: {
    paymentTypes() {
      return this.$store.state['investor-report'].paymentTypes;
    },
    requestParams() {
      const params = {
        amount: this.topUp ? this.formData.amount : `-${this.formData.amount}`,
        type: this.formData.payment_type,
        comment: this.formData.comment,
      };

      if (this.editItem) params.id = this.editItem.id;
      if (!this.topUp) params.created_at = this.formData.created_at;

      return {
        id: this.investorId,
        params,
      };
    },
  },
  methods: {
    isRequired(v) {
      const isValid = Boolean(v) || v === 0;
      return isValid || this.$t('common.fields.validation.field.required');
    },
    onlyNumbers(v) {
      if (!v) return true;
      return (
        /^[0-9]{1,12}$/.test(v) || this.$t('common.fields.validation.numbers')
      );
    },
    isItemDisable({ id }) {
      const isDisabled = this.topUp && id === 3;
      return isDisabled;
    },
    async onSubmit() {
      const isValid = this.$refs.investorTransaction.validate();

      if (!isValid) return;

      this.loading = true;
      const result = await this.$store.dispatch(
        'investor-report/addTransaction',
        this.requestParams,
      );

      this.loading = false;
      this.$emit('updated', result);
    },
    async onUpdate() {
      const isValid = this.$refs.investorTransaction.validate();

      if (!isValid) return;

      this.loading = true;
      const result = await this.$store.dispatch(
        'investor-report/editTransaction',
        this.requestParams,
      );

      this.loading = false;
      this.$emit('updated', result);
    },
  },
};
</script>

<style></style>
